var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { sessionInstance as Session } from '../helpers/api';
import { getAccessToken, setAccessToken } from '../helpers/token';
var fetchCurrent = function fetchCurrent() {
  return Session.get('/current');
};
var SessionContext = React.createContext({});
var SessionProvider = function SessionProvider(_ref) {
  var children = _ref.children,
    userInPrivateRoutes = _ref.userInPrivateRoutes;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    current = _useState2[0],
    setCurrent = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    appUser = _useState4[0],
    setAppUser = _useState4[1];
  var _useState5 = useState(getAccessToken() && !!getAccessToken().length),
    _useState6 = _slicedToArray(_useState5, 2),
    isAuthed = _useState6[0],
    setIsAuthed = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    debugMode = _useState8[0],
    setDebugMode = _useState8[1];
  var location = useLocation();
  var toggleDebugMode = function toggleDebugMode() {
    return setDebugMode(function (v) {
      return !v;
    });
  };
  useEffect(function () {
    if ((!current || !current.id) && isAuthed) {
      fetchCurrent().then(function (_ref2) {
        var r = _ref2.data.data;
        setAccessToken(r.attributes.accessToken);
        setCurrent(r);
      }).catch(function (error) {
        if (error.response.status === 401 && userInPrivateRoutes()) {
          localStorage.setItem('route-attempted', JSON.stringify(location));
        }
      });
    } else if (!isAuthed && !current && userInPrivateRoutes()) {
      localStorage.setItem('route-attempted', JSON.stringify(location));
    }
  }, []);
  return React.createElement(SessionContext.Provider, {
    value: {
      current: current,
      setCurrent: setCurrent,
      appUser: appUser,
      setAppUser: setAppUser,
      isAuthed: isAuthed,
      setIsAuthed: setIsAuthed,
      debugMode: debugMode,
      toggleDebugMode: toggleDebugMode
    }
  }, children);
};
SessionProvider.propTypes = {
  children: PropTypes.node.isRequired,
  userInPrivateRoutes: PropTypes.func.isRequired
};
export { SessionContext, SessionProvider };